import { gql } from '../types/generated';

export const ROUTE_MEDIA = gql(`
  mutation routeMedia($mediaIds: [String!]!, $routeType: RouteType) {
    routeMedia(mediaIds: $mediaIds, routeType: $routeType) {
      mediaId
      reason
      success
    }
  }
`);

export const END_AD_BREAK = gql(`
  mutation endAdBreak($mediaIds: [String]!) {
    endAdBreak(mediaIds: $mediaIds) {
      mediaId
      reason
      success
    }
  }
`);

export const SET_SLATE = gql(`
  mutation setSlate($mediaIds: [String!]!, $slateCode: String!) {
    setSlate(mediaIds: $mediaIds, slateCode: $slateCode) {
      mediaId
      reason
      success
    }
  }
`);

export const LIFT_SLATE = gql(`
  mutation liftSlate($mediaIds: [String!]!) {
    liftSlate(mediaIds: $mediaIds) {
      mediaId
      reason
      success
    }
  }
`);

export const INSERT_AD_BREAK = gql(`
  mutation insertAdBreak(
    $mediaIds: [String!]!
    $durationSeconds: Int!
    $slateCode: String!
    $eventType: String
    $includeBuffer: Boolean
  ) {
    insertAdBreak(
      mediaIds: $mediaIds
      durationSeconds: $durationSeconds
      slateCode: $slateCode
      eventType: $eventType
      includeBuffer: $includeBuffer
    ) {
      mediaId
      reason
      success
    }
  }
`);

export const SYNC_PIPELINE_ROUTING = gql(`
  mutation syncPipelineRouting ($mediaIds: [String!]!) {
    syncPipelineRouting(
      mediaIds: $mediaIds
    ) {
      mediaId
      success
      reason
    }
  }
`);
